<template>
    <div class="main" v-if="queryData.tzdId">
        <van-nav-bar
            left-arrow
            title="维修资金交存"
            @click-left="onClickLeft"
        />

        <div class="content">
            <div class="content-sub">
                <div class="top-box">
                    <h3>{{ queryData.wyqumc }}</h3>
                    <p>{{ "业主：" + queryData.yz }}</p>
                </div>
                <div class="main-box">
                    <div class="info-item">
                        <span class="desc">房屋地址：</span>
                        <p class="detail">
                            {{ queryData.fwdz }}
                        </p>
                    </div>
                    <div class="info-item">
                        <span class="desc">建筑面积：</span>
                        <p class="detail">{{ queryData.jzmj + "m²" }}</p>
                    </div>
                    <div class="info-item">
                        <span class="desc">通知单编号：</span>
                        <p class="detail">{{ queryData.tzdh }}</p>
                    </div>
                    <div class="info-item">
                        <span class="desc">交款类型：</span>
                        <p class="detail">{{ queryData.jklx }}</p>
                    </div>
                    <div class="info-item">
                        <span class="desc">应交金额：</span>
                        <p class="detail">
                            <span class="left-money">{{
                                "￥" + queryData.yjje
                            }}</span
                            ><small class="right-big-money">
                                {{ getChinaNumb(queryData.yjje) }}
                            </small>
                        </p>
                    </div>
                    <div class="info-item">
                        <span class="desc">备注：</span>
                        <p class="detail">
                            {{ queryData.bz ? queryData.bz : "暂无备注" }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="instruction">
            <span>说明：</span>
            <!-- <p>
                交存标准：根据《泸州市住宅专项维修资金管理细则》按照建筑安装造价<span
                    class="color-sty-yel"
                    >{{ queryData.jcbz }}</span
                >元/m²。
            </p> -->
            <p>
                通过线下转款或到网点办理交款的业主，需持本通知单及银行交存回执到<span
                    class="color-sty-yel"
                    >交款银行网点或代管机构</span
                >领取交存凭证。
            </p>
        </div>
        <div class="footerBox">
            <span class="left">{{ "￥" + queryData.yjje }}</span>
            <button class="primaryBtn" @click="serach" v-show="!getting">
                支付
            </button>
            <button class="getingBtn" v-show="getting">支付中...</button>
        </div>
    </div>
</template>

<script>
import { tzdH5, crateOrderId } from "@api/deposite.js";
import getChinaNumb from "../utils/moneyFormat";
export default {
    data() {
        return {
            show: false,
            // 请求控制
            getting: false,
            queryData: {},
        };
    },
    methods: {
        getChinaNumb(numb) {
            getChinaNumb(numb);
        },
        onConfirm(values, index) {
            this.show = false;
        },
        // 取消返回
        // goBack() {
        // },
        onClickLeft() {
            this.$router.go(-1);
        },
        onCancel() {
            this.show = false;
        },
        serach() {
            if (!this.queryData.tzdId) {
                return this.$toast({
                    message: "支付失败，没有通知单编号，请稍后重试！",
                    position: "top",
                });
            }
            this.getting = true;
            crateOrderId(this.queryData.tzdId)
                .then(
                    (
                       res
                    ) => {
                        this.getting = false;
                        if (res.data.code == 200) {
                           return window.open(res.data.data.url, "_self");
                        }
                        this.$toast({
                            // message: "交存失败，请稍后重试！",
                            message: res.data.msg,
                            position: "top",
                        });
                    }
                )
                .catch((err) => {
                    this.getting = false;
                    console.log(err);
                    return this.$toast({
                        message: "交存失败，请稍后重试！",
                        position: "top",
                    });
                });
        },
    },
    mounted() {
        tzdH5({ tzdId: this.$route.query.tzdid })
            .then(({ data: { code, data: innerData } }) => {
                console.log(innerData);
                if (code == 200) {
                    this.queryData = innerData;
                } else {
                    return this.$toast({
                        message: "查询失败，请稍后重试！",
                        position: "top",
                    });
                }
            })
            .catch(() => {
                return this.$toast({
                    message: "查询失败，请稍后重试！",
                    position: "top",
                });
            });
    },
    created() {
        // if (!this.$route.query.tzdid) {
        //     this.$router.push("?tzdid=-4762780893051994705");
        // }
    },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
    background-color: rgba(255, 216, 193, 0.42);
}
.van-nav-bar::after {
    border: none;
}
.text-sty {
    font-size: 20px !important;
}
::v-deep .van-icon-arrow-left:before {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    line-height: 21px;
}
::v-deep .van-nav-bar__title {
    font-size: 17px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
}
::v-deep .van-icon {
    color: #000000;
}
::v-deep .van-nav-bar__text {
    color: #000000;
}
::v-deep .van-nav-bar__title {
    color: #000000;
}
.main {
    width: 100%;
    background: #f2f4f8;
    overflow: hidden;
    color: #fff;
    padding-bottom: 80px;
    .content {
        position: relative;
        width: 100%;
        height: 600px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222120;
        line-height: 30px;
        .content-sub {
            width: 100%;
            height: 400px;
            background: linear-gradient(
                180deg,
                rgba(255, 216, 193, 0.42) 0%,
                rgba(255, 216, 193, 0) 100%
            );
            overflow: hidden;
            padding: 20px 20px 20px;
            .top-box {
                h3 {
                    margin: 0 0 18px;
                }
                p {
                    font-size: 14px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    margin: 0 0 20px;
                }
            }
        }
        .main-box {
            position: absolute;
            top: 114px;
            left: 20px;
            right: 20px;
            height: 486px;
            padding: 16px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            .info-item {
                margin-bottom: 16px;
                .desc {
                    font-size: 16px;
                    font-family: P ingFang SC-Semibold, PingFang SC;
                    font-weight: 650;
                    color: #4e4d4d;
                    line-height: 19px;
                }
                .detail {
                    margin: 3px 0 0;
                    font-size: 14px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #4e4d4d;
                    line-height: 22px;
                    .left-money {
                        font-size: 16px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #ff3566;
                        line-height: 19px;
                    }
                    .right-big-money {
                        font-size: 12px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #999998;
                        line-height: 14px;
                        margin-left: 20px;
                    }
                }
            }
            &::after {
                content: "";
                display: inline-block;
                position: absolute;
                right: 0;
                top: -94px;
                width: 120px;
                height: 120px;
                background: url("../assets/img/house-bk.png");
                background-size: 120px 120px;
                z-index: 999;
            }
        }
    }
    .instruction {
        margin: 20px 20px 0;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 24px;
        span {
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            color: #999998;
            line-height: 26px;
        }
        span.color-sty-yel {
            color: #ff6c1a;
        }
        p {
            margin: 7px 0 0;
        }
    }
    .footerBox {
        width: 100%;
        height: 60px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        padding: 20px;
        left: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        span {
            font-size: 20px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ff3566;
            line-height: 60px;
        }
        button {
            &.primaryBtn,
            &.getingBtn {
                width: 96px;
                height: 42px;
                background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
                border-radius: 21px 21px 21px 21px;
                opacity: 1;
                border: none;
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 19px;
                transition: 0.7s all;
            }
            &.getingBtn {
                background: gray;
            }
        }
    }
}
</style>
